import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import ShareableLinkField from "./ShareTrivia/ShareableLinkField";
import { SHARE_LINK_DIALOG_TITLE } from "./ShareTrivia/shareCopy";
import { SHORT_LINK_ITEM_TYPES, SHORT_LINK_SOURCES } from "../../../utils/trivvyShortLink";
import { contvertHTMLToPlain } from "../../../utils/constants";
import "./ShareTrivia/sharepage.css";

// TBV-938: on-demand Copy Link for list rows WITHOUT a server-built shortUrl
// (legacy items), or when a one-click copy was refused by the browser. The
// link is resolved here and copied by a separate, fresh user click on Copy —
// Safari / mobile drop clipboard writes chained after a network request.
const ShortLinkCopyDialog = ({ item, fallbackUrl, onClose, onResolved }) => {
  const isOpen = Boolean(item);
  return (
    <Modal isOpen={isOpen} toggle={onClose} className="shareModal" centered>
      <ModalHeader toggle={onClose}>{SHARE_LINK_DIALOG_TITLE}</ModalHeader>
      <ModalBody>
        {isOpen && (
          <>
            <p className="mb-3 font-weight-bold text-truncate">
              {contvertHTMLToPlain(item.name || "")}
            </p>
            <ShareableLinkField
              itemType={SHORT_LINK_ITEM_TYPES.TRIVVY}
              itemId={item._id}
              source={SHORT_LINK_SOURCES.LIST_MENU}
              knownShortUrl={item.shortUrl}
              fallbackUrl={fallbackUrl}
              onResolved={(shortUrl) => {
                if (onResolved) {
                  onResolved(item._id, shortUrl);
                }
              }}
            />
          </>
        )}
        <div className="share_footer">
          <Button className="share_btn_text" onClick={onClose}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ShortLinkCopyDialog;
